import React from "react";
import { Link } from "react-router-dom";

function NestedNavBar() {
  return (
    <nav
      className="navbar
      navbar-expand-md bg-dark navbar-dark"
      style={{ width: "98%", marginLeft: "-8px", marginBottom: "16px" }}
    >
      {/* Brand */}
      <Link to="/" className="navbar-brand">
        <img
          src={require("./Parking Logo.jpg")}
          alt="Parking"
          style={{ width: "85px", height: "20px", marginLeft: "5px" }}
        />
      </Link>
      {/* <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#topNavbarDiv"
        aria-controls="topNavbarDiv"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button> */}
      <div className="container-fluid" id="topNavbarDiv">
        <ul className="navbar-nav">
          <li className="nav-item">
            <Link id="navlink" className="px-2" to="/">
              Home
            </Link>
          </li>
          <li className="nav-item">
            <Link id="navlink" className="px-2" to="./Policies">
              General Policies
            </Link>
          </li>
          <li className="nav-item">
            <Link id="navlink" className="px-2" to="./ColumbiaLocTab">
              Columbia
            </Link>
          </li>
          <li className="nav-item">
            <Link id="navlink" className={"px-2"} to="./AllenLocTab">
              Allen
            </Link>
          </li>
          <li className="nav-item">
            <Link id="navlink" className="px-2" to="./CornellLocTab">
              Cornell
            </Link>
          </li>
          <li className="nav-item">
            <Link id="navlink" className="px-2" to="./MethodistLocTab">
              Methodist
            </Link>
          </li>
          <li className="nav-item">
            <Link id="navlink" className="px-2" to="./SpruceLocTab">
              Lower Manhattan
            </Link>
          </li>
          <li className="nav-item">
            <Link id="navlink" className="px-2" to="./Applications">
              Applications
            </Link>
          </li>
          <li className="nav-item">
            <Link id="navlink" className="px-2" to="./AltParkingTab">
              Alternate Parking
            </Link>
          </li>
          <li className="nav-item">
            <Link id="navlink" className="px-2" to="/NestedNav">
              Rates
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}
export default NestedNavBar;
